import _ from "lodash";
import { handleActions } from "redux-actions";
import { WORKING_ORDER } from "constants/action-types";
import { initialBaseState, fetchActions, IFetchStoreState, type IResponse } from "../base-reducers";
import { ICartAvailability } from "types/availability";

export interface IProductsAvailabilityFetchState extends IFetchStoreState<ICartAvailability> {
    isFetching: boolean;
    error?: Error & { status?: number };
    cache?: string[];
}

export const availability = handleActions<IProductsAvailabilityFetchState>(
    {
        ...fetchActions(WORKING_ORDER.AVAILABILITY.FETCH),
        [WORKING_ORDER.AVAILABILITY.PRODUCTS_CACHE.CLEAR]: (state: IProductsAvailabilityFetchState) => ({
            ...state,
            cache: [],
        }),
        [WORKING_ORDER.AVAILABILITY.FETCH.SUCCESS]: (
            state: IProductsAvailabilityFetchState,
            { payload, meta }: IResponse<{ data: ICartAvailability; productIds: string[] }>
        ) => ({
            ...state,
            payload: _.mergeWith(payload?.data, state.payload, (x = {}, y = {}) => ({ ...x, ...y })),
            cache: _.uniq([...(state?.cache || []), ...(payload?.productIds || [])]),
            meta,
            error: null,
            isFetching: false,
        }),
    } as any,
    initialBaseState
);
